import { parseUnitToNum } from '../../../../utils/cssunitparser';
import * as basicScroll from 'basicscroll';

const MENU_HEIGHT = parseUnitToNum(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));

const ATTRS = ['data-cover', 'data-startdate'];

export class EventPageTopHTMLElement extends HTMLElement {
    private observer: IntersectionObserver;
    private parallaxInstance: any;
    private resizeTimeout: any;
    private windowWidth: number;

    static get observedAttributes(): string[] {
        return ATTRS;
    }

    public attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
        if (!ATTRS.includes(name) || oldValue === newValue) {
            return;
        }

        switch (name) {
            case 'data-cover':
                if (oldValue !== null) {
                    this.cleanUpParallax();
                }
                if (newValue !== null) {
                    this.parallaxEffect();
                }
                break;
            case 'data-startdate':
                this.setBadgeCountdown();
                break;
        }
    }

    private cleanUpParallax = () => {
        this.parallaxInstance?.destroy();
        window.removeEventListener('resize', this.resize);
    };

    private parallaxEffect() {
        Promise.resolve().then(() => {
            if (!this.getAttribute('data-cover')) {
                return;
            }

            this.parallaxInstance = basicScroll.create({
                elem: this.querySelector('.eventpagetop__cover'),
                from: 'top-middle',
                to: 'bottom-middle',
                direct: this,
                track: false,
                props: {
                    '--ty': {
                        from: 0,
                        to: '12.5%'
                    }
                }
            });

            this.parallaxInstance.start();
            window.addEventListener('resize', this.resize);
            this.windowWidth = window.innerWidth;
        });
    }

    private resize = () => {
        if (this.windowWidth === window.innerWidth) {
            return;
        }
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
            this.parallaxInstance.calculate();
            this.parallaxInstance.update();
            this.windowWidth = window.innerWidth;
        }, 200);
    }

    private setBadgeCountdown = () => {
        const now = Date.now();
        const startDate = Number(this.dataset.startdate);

        const badge = this.querySelector<HTMLElement>('.eventpagetop__badge');

        if (startDate > now) {
            badge.style.display = 'block';

            const remaining = (startDate - now) / (24 * 60 * 60 * 1000);

            badge.innerText = remaining < 1 ? 'last day'
                    : remaining < 2 ? '1 remaining day'
                    : `${Math.floor(remaining)} remaining days`;
        } else {
            badge.style.display = '';
        }
    }

    public connectedCallback(): void {
        Promise.resolve().then(() => {
            this.observer = new IntersectionObserver(entries => {
                for (const e of entries) {
                    this.querySelector('.infobox').classList
                        .toggle('fixed', !e.isIntersecting && e.target.getBoundingClientRect().bottom < 0);
                }
            }, {
                rootMargin: `${MENU_HEIGHT}px 0px 0px 0px`
            });
            this.observer.observe(this);
        });

        this.parallaxEffect();

        this.setBadgeCountdown();
    }

    public disconnectedCallback(): void {
        this.cleanUpParallax();
        this.observer.disconnect();
    }
}